import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { List as ImmutableList } from 'immutable';
import { stringify } from 'hub-http/helpers/params';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import UsageTracker from '../../../utils/UsageTracker';
import { useGetToolRecommendations } from '../queries/softwareDiscoveryHooks';
import { SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS } from '../../../constants/Navigation';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUISelectableButton = styled(UISelectableButton).withConfig({
  displayName: "ToolRecommendationsForLearningContent__StyledUISelectableButton",
  componentId: "sc-7lbyht-0"
})(["height:100%;"]);
const ToolCard = ({
  cardWidth,
  contentName,
  experimentUseCase,
  iconWidth,
  linkText,
  name,
  toolSlug,
  resourceTitle,
  title
}) => {
  const handleToolClick = () => UsageTracker.track('contentInteraction', {
    action: 'software-discovery-tool-click',
    contentName,
    linkText,
    resourceTitle,
    useCases: [experimentUseCase]
  });
  return /*#__PURE__*/_jsx(UIBox, {
    basis: cardWidth,
    shrink: 0,
    children: /*#__PURE__*/_jsx(Link, {
      "data-test-id": `tool-recommendation-card-${name}`,
      style: {
        textDecoration: 'none',
        color: 'inherit'
      },
      target: "_blank",
      to: {
        pathname: `/${SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS}/${toolSlug}`,
        search: stringify({
          useCases: experimentUseCase
        })
      },
      children: /*#__PURE__*/_jsx(StyledUISelectableButton, {
        block: true,
        external: true,
        onClick: handleToolClick,
        selected: false,
        size: "large",
        title: title,
        children: /*#__PURE__*/_jsx(UIIllustration, {
          name: name,
          width: iconWidth
        })
      })
    })
  });
};
const ToolRecommendationsForLearningContent = ({
  cardWidth = 350,
  contentName,
  iconWidth = '65%',
  renderRecommendations = commonContent => commonContent,
  toolsToDisplay = 3,
  useCases: mayBeListUseCase,
  flexGap = 0
}) => {
  const useCases = useMemo(() => {
    if (ImmutableList.isList(mayBeListUseCase)) {
      return mayBeListUseCase.toArray();
    }
    return mayBeListUseCase;
  }, [mayBeListUseCase]);
  const toolRecommendations = useGetToolRecommendations(useCases);
  useEffect(() => {
    if (toolRecommendations) {
      UsageTracker.track('interaction', {
        action: 'software-discovery-ui-viewed',
        useCases
      });
    }
  }, [toolRecommendations, useCases]);
  if (!toolRecommendations) {
    return null;
  }
  const {
    experimentUseCase,
    toolCardNames,
    toolNames,
    toolLabelTitles,
    toolCardLinks,
    toolSlug
  } = toolRecommendations;
  return renderRecommendations( /*#__PURE__*/_jsx(UIFlex, {
    align: "stretch",
    gap: flexGap,
    justify: "around",
    wrap: "wrap",
    children: [...Array(toolsToDisplay)].map((_, index) => /*#__PURE__*/_jsx(ToolCard, {
      cardWidth: cardWidth,
      contentName: contentName,
      experimentUseCase: experimentUseCase,
      iconWidth: iconWidth,
      link: toolCardLinks[index],
      linkText: I18n.text(toolLabelTitles[index]),
      name: toolCardNames[index],
      resourceTitle: toolNames[index],
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: toolLabelTitles[index]
      }),
      toolSlug: toolSlug[index]
    }, index))
  }));
};
export default ToolRecommendationsForLearningContent;